import { useAuth } from "../auth/AuthProvider";

/**
 * The signed-in account's IANA timezone, for every timestamp on screen.
 *
 * Reading it from `/me` rather than the browser keeps two panels showing the
 * same moment in agreement. Falling back to `undefined` lets the formatters use
 * the browser zone, which is the right guess and never throws.
 */
export function useAccountTimeZone(): string | undefined {
  const { user } = useAuth();
  return user?.account?.timezone;
}
